module.exports = __webpack_public_path__ + "static/media/Collie - Pastel.8fe5006f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/Collie - Pastel.jpg
 ** module id = 392
 ** module chunks = 0
 **/